import { SVGProps } from "react";

export function RightArrow (props: SVGProps<SVGSVGElement>) {
    return <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.99935 0.666626L5.05935 1.60663L8.77935 5.33329L0.666016 5.33329L0.666016 6.66663L8.77935 6.66663L5.05935 10.3933L5.99935 11.3333L11.3327 5.99996L5.99935 0.666626Z" fill="currentColor"/>
    </svg>
    
}